import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import { FAIcon } from './FAIcon'
import { DataGrid } from '@mui/x-data-grid'
import _ from 'common-tools/LodashHelper'
import Paper from '@mui/material/Paper'
import styles from './DataGrid.less'
import moment from 'moment'

export class MUIDataGrid extends React.Component {
  static pt = {
    data: pt.array,
    onLoadMore: pt.func,
    loading: pt.bool.isRequired
  }

  static defaultProps = {
    loading: false
  }

  renderLoadMore (results, loading) {
    const { onLoadMore } = this.props

    if (_.isArray(results) === false) {
      return null
    }

    return <div className={styles.loadMore}>
      {loading
        ? <FAIcon name='spinner' spin size='24px' toolTip='Loading...' className='menu' overlayClassName='menu' />
        : <FAIcon name='chevron-down' size='24px' toolTip='Load More' className='menu' overlayClassName='menu' onClick={onLoadMore} />
      }

    </div>
  }
 // headers render uppercase and carry a sort/menu icon, so a column needs more than the
 // bare text width or short headers like YEAR get clipped to an ellipsis
 getTextWidth = (text, padding = 56) => {
   if (!text) return 130
   return Math.max(text.length * 9 + padding, 90)
 };
  formatHeader = (key) => {
    return _.startCase(key)
  }
  isIsoDate = (value) => {
    return (
      _.isString(value) &&
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,6})?)?([+-]\d{2}:?\d{2}|Z)?$/.test(
      value
    )
    )
  }
  render () {
    // rowHeight/disableSelectionOnClick must never reach the grid as undefined: v5 spreads
    // incoming props over its own defaults, so an explicit undefined wipes the default out
    // and every row collapses to its natural ~20px height with a 1px scroll area.
    const { data, onClick, mode = '', listFields, loading, drawer, className, rowHeight = 52, disableSelectionOnClick = false } = this.props
    let columns, rows
    if (loading && (!data || data.length === 0)) {
      return <div className={styles.loadMore}>
        <FAIcon name='spinner' spin size='24px' toolTip='Loading...' className='menu' overlayClassName='menu' />
      </div>
    }
    const filteredData = _.map(data, (row) =>
      _.pick(row, [..._.map(listFields, 'field')])
    )
    if (mode === 'normal') {
      columns = Object.keys(filteredData).map((key) => ({
        field: key,
        headerName: key,
        flex: 1
      }))
      rows = [{ id: 1, ...filteredData }]
    } else {
      columns = _.map(listFields, ({ field, header, width, flex, minWidth, renderCell }) => {
        const longestValue = _.maxBy(filteredData, (row) =>
          row[field] ? row[field].toString().length : 0
        )
        const rawVal = _.get(longestValue, field)
        const longestText = (rawVal != null ? rawVal.toString() : null) || header
        const sizedWidth = this.getTextWidth(longestText.length > header.length ? longestText : header)
        const column = {
          field,
          headerName: header,
          valueFormatter: (params) => {
            const value = params.value
            if (this.isIsoDate(value)) {
              return moment(value).format('MMM D, YYYY h:mm A')
            }
            return value || ''
          }
        }
        // a listField can supply its own cell renderer for icons/rich content
        if (renderCell) {
          column.renderCell = renderCell
        }
        // a listField can set `flex` to share out the full grid width, or `width`
        // to pin a size; without either the column is sized to its longest value
        if (flex) {
          column.flex = flex
          column.minWidth = minWidth || sizedWidth
        } else {
          column.width = width || sizedWidth
        }
        return column
      })
      rows = _.map(data, (item, idx) => ({
        id: item.Id != null ? item.Id : idx,
        ...item
      }))
    }

    return (
      <div className={className}>
        <Paper sx={{ width: '100%', marginBottom: '10px' }}>
          <DataGrid
            autoHeight
            rows={rows}
            columns={columns}
            initialState={{ pagination: { pageSize: 25 } }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowHeight={rowHeight}
            disableSelectionOnClick={disableSelectionOnClick}
            sx={{ border: 0 }}
            onRowClick={(params) => { if (onClick) onClick(params.row, drawer) }}
          />
        </Paper>
      </div>
    )
  }
}
